module.exports = __webpack_public_path__ + "static/media/plan_question_type.611959ba.png";